import React from 'react'
import Modal from 'react-bootstrap/Modal';

function MensageInformacion(props) {
    const { msg, show ,callback} = props;
    return (
        <Modal show={show} contentClassName="bg-transparent "
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header bsPrefix="modal-header m-0 p-0">
                <div className='verPedidoButon w-100 text-center my-auto py-1'
                    style={{ borderTopRightRadius: '10px', borderTopLeftRadius: '10px' }}>
                    <div className='text-white textTitle'>NOTIFICACIÓN</div>
                </div>
            </Modal.Header>
            <Modal.Body bsPrefix="modal-body m-0 p-0 bg-light">
                <div className='container-fluid py-2'>
                    <p className='textInfo text-center mb-1'>{msg}</p>
                </div>
            </Modal.Body>
            <Modal.Footer bsPrefix="modal-footer text-center m-0 p-0 mx-auto bg-light w-100">
                <button className="btn botonPlomo text-light rounded-pill" onClick={() => { callback(false) }}>
                    Cancelar
                </button>
                <button className="btn botonNaranja text-light rounded-pill" onClick={() => { callback(true) }}>
                    Continuar
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default MensageInformacion
